import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../AppContext";
import CanvasJSReact from "@canvasjs/react-charts";
import axios from "axios";
import { BASE_URL } from "../../constant";
import { useParams } from "react-router-dom";
import { formatDate } from "@telerik/kendo-intl";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";

var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const Graph = ({
  graphData,
  dateRange,
  index,
  ChangeDateRange,
  findAlarm,
  findDataPointAlarm,
  alarmLines,
  playBackMode,
  momentData,
  getTimeZoneDateTime,
  assetId,
}) => {
  const { config } = useContext(AppContext);
  const { timeZone } = config;
  const alrmStriplines = graphData.default
    ? findAlarm(graphData.id)
    : findAlarm(graphData.parameterId);
  const options = {
    animationEnabled: true,
    theme: "dark1",
    backgroundColor: "black",
    toolTip: {
      enabled: true, //disable here
      animationEnabled: true, //disable here
      fontSize: 12,
      fontFamily: "poppins",
      contentFormatter: function (e) {
        var content = " ";
        for (var i = 0; i < e.entries.length; i++) {
          content +=
            CanvasJS.formatDate(
              e.entries[i].dataPoint.x,
              "DD-MMM-YYYY hh:mm TT"
            ) +
            " : " +
            parseFloat(e.entries[i].dataPoint.y.toFixed(2));
          content += "<br/>";
        }
        return content;
      },
    },
    axisY: {
      labelFontSize: 8,
      gridThickness: 0,
      minimum: graphData.graphRange ? graphData.graphRange?.min : 0,
      maximum: graphData.graphRange ? graphData.graphRange?.max : 100,
      stripLines: [],
    },
    axisX: {
      labelFontSize: 8,
      labelAutoFit: true,
      labelWrap: true, // change to false
      labelAngle: 0,
      minimum: new Date(dateRange.startDate),
      maximum: new Date(dateRange.endDate),
      labelFormatter: function (e) {
        return formatDate(getTimeZoneDateTime(e.value), "dd-MMM-yyyy hh:mm a");
      },
      gridThickness: 0,
    },

    zoomEnabled: true,
    data: [
      {
        type: graphData?.graphType || "line",
        markerColor: "white",
        dataPoints: graphData.dataPoints,
      },
    ],
  };
  const { data } = useContext(AppContext);
  const [dataPoints, setDataPoints] = useState({
    ...options,
    axisX: {
      ...options.axisX,
      minimum: new Date(dateRange.startDate),
      maximum: new Date(dateRange.endDate),
    },
  });

  useEffect(() => {
    if (graphData)
      setDataPoints((pre) => ({
        ...pre,
        axisY: {
          ...pre.axisY,
          minimum: graphData?.graphRange?.min || 0,
          maximum: graphData?.graphRange?.max || 100,
        },
        data: [
          {
            ...pre.data[0],
            type: graphData.graphType,
            markerType: graphData?.showPoints ? "circle" : "none",
            markerSize: 3,
            markerColor: "white",
            dataPoints: graphData.dataPoints,
            lineColor: graphData?.pointColour || "white",
          },
        ],
      }));
  }, [graphData]);

  useEffect(() => {
    setDataPoints((pre) => ({
      ...pre,
      axisX: {
        ...pre.axisX,
        minimum: new Date(dateRange.startDate),
        maximum: new Date(dateRange.endDate),
      },
    }));
  }, [dateRange]);

  useEffect(() => {
    setDataPoints((pre) => ({
      ...pre,
      axisY: {
        ...pre.axisY,
        stripLines: alarmLines ? alrmStriplines : [],
      },
    }));
  }, [alarmLines]);

  const renderData = (currentData) => {
    if (playBackMode === 100) ChangeDateRange();
    console.log(assetId, graphData.parameterId, graphData.sensorId);
    const paramObj = currentData.Values?.find(
      (v) =>
        v.Id === graphData.sensorId &&
        v.ParameterId === graphData.parameterId &&
        v.AssetId === assetId
    );

    if (paramObj) {
      const newPoint = {
        x: new Date(
          new Date(getTimeZoneDateTime(currentData.timeStamp, timeZone))
        ),
        y: parseFloat(paramObj.Value),
        markerColor: findDataPointAlarm(
          graphData.parameterId,
          parseFloat(paramObj.Value)
        ),
        markerSize: 3,
      };

      setDataPoints((pre) => ({
        ...pre,
        data: [
          {
            ...pre.data[0],
            dataPoints: [...pre.data[0].dataPoints, newPoint],
          },
        ],
      }));
    }
  };

  useEffect(() => {
    console.log(playBackMode, momentData, "playback");
    if (playBackMode === 200 && momentData && momentData.data)
      if (!momentData.dragging) renderData(momentData.data);
      else {
        const newData = {
          ...dataPoints,
          data: [
            {
              ...dataPoints.data[0],
              dataPoints: [
                {
                  x: new Date(dateRange.startDate),
                  y: 0,
                  markerColor: "white",
                  markerSize: 4,
                },
              ],
            },
          ],
        };
        setDataPoints(newData);
        momentData.rangeDatas.forEach((x) => {
          renderData(x);
        });
      }
  }, [momentData?.data]);

  useEffect(() => {
    if (playBackMode === 100) renderData(data);
  }, [data]);

  return <CanvasJSChart options={dataPoints} key={index} />;
};

const Graphs = forwardRef(
  (
    { assetData, mode, playBackDateRange, alarmLines, momentData, assetConfig },
    ref
  ) => {
    const { playbackMode, setPlayBackMode, getTimeZoneDateTime } =
      useContext(AppContext);
    const getCurrentTime = () => {
      var currentTime = getTimeZoneDateTime(new Date());
      var newTime = new Date(currentTime.getTime() + 30 * 60000);
      return newTime;
    };

    const [expanded, setExpanded] = useState(null);
    const [graphdata, setGraphData] = useState([]);
    const [dateRange, setDateRange] = useState({
      startDate: getCurrentTime(),
      endDate:
        getTimeZoneDateTime(new Date().getTime() + 30 * 60 * 1000)
          .toISOString()
          .slice(0, 23) + "Z",
    });

    const onExpandClick = (id) => {
      if (expanded === null) {
        setExpanded(id);
      } else {
        setExpanded(null);
      }
    };

    useImperativeHandle(ref, () => ({
      clearChildState() {
        setGraphData((pre) => pre.map((x) => ({ ...x, dataPoints: [] })));
      },
    }));

    const ChangeDateRange = () => {
      let cTime = getCurrentTime();
      let lastHour = new Date(cTime.getTime() - mode.graph * 60 * 60 * 1000)
        .toISOString()
        .slice(0, 23);
      setDateRange({ startDate: lastHour, endDate: cTime });
    };

    const findParameter = (id) => {
      const param = assetData?.parameters.find((s) => s.id === id);
      return param;
    };

    const getHistoryData = async (configuredGraph) => {
      const cTime = getTimeZoneDateTime(new Date());
      const lastHour = new Date(cTime.getTime() - mode.graph * 60 * 60 * 1000)
        .toISOString()
        .slice(0, 23);

      const payload = configuredGraph
        .filter((cg) => cg.deviceId !== null)
        .map(({ deviceId, parameterId }) => ({
          deviceId,
          parameterId,
          assetId: assetData.id,
        }));

      try {
        const res = await axios.post(
          `${BASE_URL}/api/DeviceData/DataByDeviceIdAndRange?startTime=${lastHour}&endTime=${cTime
            .toISOString()
            .slice(0, 23)}`,
          payload
        );
        const startData = res.data.find((x) => x.timeStamp === lastHour);

        const finaldata = configuredGraph.map((s) => {
          const sensorValues = res.data.flatMap((rd) => {
            const sensorValue = rd.values.find(
              (v) => v.parameterId === s.parameterId && v.id === s.sensorId
            )?.value;

            return sensorValue
              ? {
                  x: getTimeZoneDateTime(rd.timeStamp),
                  y: parseFloat(sensorValue),
                  markerColor: findDataPointAlarm(
                    s.default ? s.id : s.parameterId,
                    parseFloat(sensorValue)
                  ),
                  markerSize: 3,
                }
              : null;
          });

          return {
            ...s,
            dataPoints:
              sensorValues.length > 0
                ? [
                    !startData && {
                      x: new Date(lastHour),
                      y: 0,
                      markerColor: "white",
                      markerSize: 3,
                    },
                    ...sensorValues,
                  ].filter((x) => x !== null)
                : [
                    {
                      x: new Date(cTime),
                      y: 0,
                      markerColor: "white",
                      markerSize: 3,
                    },
                    {
                      x: new Date(lastHour),
                      y: 0,
                      markerColor: "white",
                      markerSize: 3,
                    },
                  ],
          };
        });
        setPlayBackMode((pre) => {
          if (pre === 100) setGraphData(finaldata);
          return pre;
        });
      } catch (error) {
        // Handle the error appropriately
        console.error(error);
      }
    };

    useEffect(() => {
      if (mode.graph !== null) {
        const finaldata = assetConfig
          ?.map((s) => {
            const parameter = findParameter(s.id);
            return parameter
              ? {
                  ...s,
                  id: s.id,
                  name: parameter?.name,
                  unit: parameter?.unit,
                  deviceId: parameter?.deviceId,
                  sensorId: parameter?.sensorId,
                  parameterId: parameter?.parameterId,
                  default: parameter?.default,
                  dataPoints: [],
                }
              : null;
          })
          .filter((x) => x !== null);
        setGraphData(finaldata);
        setPlayBackMode((pre) => {
          if (pre === 100) getHistoryData(finaldata);
          return pre;
        });
        ChangeDateRange();
      }
    }, [assetConfig, mode.graph, playbackMode]);

    useEffect(() => {
      if (
        playbackMode === 200 &&
        playBackDateRange.startDate &&
        playBackDateRange.endDate
      ) {
        setDateRange({
          startDate: playBackDateRange.startDate,
          endDate: playBackDateRange.endDate,
        });
      } else ChangeDateRange();
    }, [playBackDateRange]);

    const findAlarm = (paramId) => {
      const alrm = assetData?.alarms.find((a) => a.parameterId === paramId);
      const alrmlines = [];

      const addAlarmLine = (value, label, color) => {
        alrmlines.push({
          value,
          label,
          color,
          labelFontColor: color,
          lineDashType: "longDash",
          labelPlacement: "inside",
          labelBackgroundColor: "transparent",
          labelFontSize: 12,
          labelFontWeight: "bold",
        });
      };

      if (alrm && alrm.infoEnabled) {
        addAlarmLine(alrm.infoLowerLimit, alrm.infoLowerLimit, "rgb(0,255,0)");
        addAlarmLine(alrm.infoUpperLimit, alrm.infoUpperLimit, "rgb(0,255,0)");
      }

      if (alrm && alrm.warningEnabled) {
        addAlarmLine(
          alrm.warningLowerLimit,
          alrm.warningLowerLimit,
          "rgb(255,165,0)"
        );
        addAlarmLine(
          alrm.warningUpperLimit,
          alrm.warningUpperLimit,
          "rgb(255,165,0)"
        );
      }

      if (alrm && alrm.criticalEnabled) {
        addAlarmLine(
          alrm.criticalLowerLimit,
          alrm.criticalLowerLimit,
          "rgb(255,0,0)"
        );
        addAlarmLine(
          alrm.criticalUpperLimit,
          alrm.criticalUpperLimit,
          "rgb(255,0,0)"
        );
      }

      return alrmlines;
    };

    const findDataPointAlarm = (paramId, value) => {
      const alrm = assetData?.alarms.find((a) => a.parameterId === paramId);
      if (alrm !== undefined) {
        if (
          alrm.criticalEnabled &&
          (value > alrm.criticalUpperLimit || value < alrm.criticalLowerLimit)
        )
          return "rgb(255,0,0)";
        else if (
          alrm.warningEnabled &&
          (value > alrm.warningUpperLimit || value < alrm.warningLowerLimit)
        )
          return "rgb(255,165,0)";
        else if (
          alrm.infoEnabled &&
          (value > alrm.infoUpperLimit || value < alrm.infoLowerLimit)
        )
          return "rgb(0,255,0)";
        else return "#fcfcfc";
      } else return "#fcfcfe";
    };

    return (
      <div
        className={` md:px-4 px-1 grid gap-4 mb-4 md:h-full h-5/6 ${
          graphdata.length === 2
            ? "grid-col-1 grid-rows-2 gap-y-4 "
            : graphdata.length === 1
            ? "grid-col-1 grid-rows-1 w-full"
            : "grid-cols-2 md:gap-x-2 gap-x-1"
        }`}
      >
        {graphdata.map((g, index) => (
          <div
            className={`${
              expanded === g.id
                ? "col-span-2 row-span-2"
                : expanded === null
                ? "h-full"
                : "hidden"
            } transition-all w-full ease-in-out delay-150`}
            id={g.id}
            key={index}
          >
            <label
              className={`${
                expanded === g.id ? "text-sm" : "text-xxs"
              } transition-all ease-in-out delay-150 dark:text-slate-300 text-black`}
            >
              {
                assetData.devices.find((d) => d.device.id === g?.deviceId)
                  ?.device.name
              }
              {/* &nbsp;&nbsp;|&nbsp;&nbsp;{g.name} */}
              &nbsp;&nbsp;|&nbsp;&nbsp;
              {g.name}
              &nbsp;&nbsp;{g.unit ? "(" + g.unit + ")" : ""}
            </label>
            <div
              className="canvasChart h-full"
              onDoubleClick={() => onExpandClick(g.id)}
            >
              <Graph
                dateRange={dateRange}
                index={index}
                graphData={g}
                key={index}
                ChangeDateRange={ChangeDateRange}
                findAlarm={findAlarm}
                findDataPointAlarm={findDataPointAlarm}
                alarmLines={alarmLines}
                playBackMode={playbackMode}
                momentData={momentData}
                assetId={assetData.id}
                getTimeZoneDateTime={getTimeZoneDateTime}
              />
            </div>
          </div>
        ))}
      </div>
    );
  }
);

export default Graphs;
